/**
 * Reference list of known feature uids for developer autocomplete only.
 * NOT a validation gate: any string is a valid uid, and unknown uids evaluate
 * to `false` (see FeatureFlagsFacade.isActive). Add new uids here for
 * discoverability. Mirrors GBE's known-feature-flags.ts.
 */
export const KNOWN_FEATURE_FLAGS = {
  // EXAMPLE: NEW_ENTITY_COHERENCE_CHECK: 'new_entity_coherence_check',
  ENABLE_AI_ASSISTANT: 'enable_ai_assistant',
  ENABLE_DEPLOY_PLAN: 'enable_deploy_plan',
  ENABLE_LIVE_PLAN_EDIT: 'enable_live_plan_edit',
  ENABLE_LIVE_PLAN_EDIT_REGISTRATIONS: 'enable_live_plan_edit_registrations',
  ENABLE_PATH_FILTERS: 'enable_path_filters',
  ENABLE_ROUTE_VEHICLE_REASSIGNMENT: 'enable_route_vehicle_reassignment',
  // Opens the optimizations history to every user. Off/absent => only SUPER_USER and ROOT
  // see it. The page lives outside any data space, so roll it out unrestricted.
  SHOW_OPTIMIZATIONS_MENU: 'show_optimizations_menu'
} as const;

export type KnownFeatureFlag =
  (typeof KNOWN_FEATURE_FLAGS)[keyof typeof KNOWN_FEATURE_FLAGS];
